import React, { useEffect, useState } from 'react'
import ReactExport from 'react-data-export'
import { useGlobalStore } from '../../store'
import { Download } from '../../assets/images/icons'
import { IconExcel } from '../../assets/images/iconsV2'
import { MuiButton, MuiButtons, IsLocalHost } from '../../components'
import { useExportToCsvObjects } from '../../hooks/useExportToCsvObjects'

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet

const DownloadExcelContent = ({ type, downloadId, data, title, buttonName, tabId, parentTitle, mainTitle, InsightsElementId }) => {
  // console.log('DownloadExcelContent========', type, downloadId, data, title, buttonName, tabId, parentTitle, mainTitle, InsightsElementId)

  const { isCSVModalActive, exportToCsvCount, exportToCsvObject, csvSubLhs } = useGlobalStore()
  const [sheetCount, setSheetCount] = useState(1)
  const [state, setState] = useState([])
  const [excelSheetName, setExcelSheetName] = useState('Sheet 1')
  const [state2, setState2] = useState([[]])
  const [excelSheetName2, setExcelSheetName2] = useState('Sheet 2')
  const [state3, setState3] = useState([[]])
  const [excelSheetName3, setExcelSheetName3] = useState('Sheet 3')
  const [state4, setState4] = useState([[]])
  const [excelSheetName4, setExcelSheetName4] = useState('Sheet 4')
  const { updatingExportToCsvObject } = useExportToCsvObjects()

  // const defaultCss = { alignment:{wrapText: true, vertical:'top'}, font: { sz: "12", color: { rgb: "333" }} }
  const defaultHeaderCss = {
    alignment: { wrapText: true, vertical: 'top', horizontal: 'top' },
    font: { sz: '12', bold: true, color: { rgb: '333' } },
  }
  const sentimentsArray = [
    { title: 'Positive Percent', width: { wch: 15 }, style: defaultHeaderCss },
    { title: 'Neutral Percent', width: { wch: 15 }, style: defaultHeaderCss },
    { title: 'Mixed Percent', width: { wch: 15 }, style: defaultHeaderCss },
    { title: 'Negative Percent', width: { wch: 15 }, style: defaultHeaderCss },
  ]

  const filename =
    'download--' + (title + '')?.toLowerCase()?.replaceAll(' ', '-') || title || 'download'
  const getSearchDriversKeywordsList = (data) => {
    const dataObj = data
    let objNew = []
    for (let i = 0; i < dataObj?.length; i++) {
      const item = dataObj[i]
      objNew.push([{ value: `${item.name}`, style: defaultHeaderCss }])
      if (item?.details?.length > 0) {
        for (let j = 0; j < item?.details?.length; j++) {
          objNew.push([{ value: `${item?.details[j]}` }])
        }
      }
      objNew.push([{ value: ' ' }])
      objNew.push([{ value: ' ' }])
    }
    return [
      {
        columns: [
          {
            title: 'The words/phrases are arrayed in decreasing order of search volume.',
            width: { wch: 60 },
            style: { font: { italic: true } },
          },
        ],
        data: objNew,
      },
    ]
  }

  const generateExcelData = () => {
    if (type === 'SearchDrivers__') {
      let objNew = getSearchDriversKeywordsList(data.pptVerbatims)
      setState([
        {
          columns: [
            { title: 'Driver', width: { wch: 30 }, style: defaultHeaderCss },
            { title: 'Total Percent', width: { wch: 15 }, style: defaultHeaderCss },
          ],
          data: data.searchDrivers,
        },
      ])
      setExcelSheetName('Search Drivers')
      setState2([
        {
          columns: [
            {
              title: 'The words/phrases are arrayed in decreasing order of search volume.',
              width: { wch: 60 },
              style: { font: { italic: true } },
            },
          ],
          data: objNew,
        },
      ])
      setExcelSheetName2('Verbatims')
      setSheetCount(2)
    } else if (type === 'ImpactDestinations' || type === 'ImpactDestinationsAndProgression') {

      let objNew = []
      let isExpertPost = data?.filter(
        (f) =>
          f?.ExpertPostTitle?.length > 0 &&
        f?.ExpertPostSentiment?.length > 0 &&
        f?.ExpertPostURL?.length > 0
      )?.length

      for (let i = 0; i < data?.length; i++) {
        const item = data[i]
        objNew.push([
          { value: `${item.Name}` },
          { value: `${item.Platform}` },
          { value: `${isExpertPost ? item.URL : ''}` },
          { value: `${isExpertPost ? item.ConsumerCommentsAnalysis : ''}` },
          { value: `${isExpertPost ? item.NetSentiment : ''}` },
          { value: `${isExpertPost ? item.ExpertPostTitle : ''}` },
          { value: `${isExpertPost ? item.ExpertPostSentiment : ''}` },
          { value: `${isExpertPost ? item.ExpertPostURL : ''}` },
        ])
      }

      setState([
        {
          columns: [
            { title: 'Name', width: { wch: 40 }, style: defaultHeaderCss },
            { title: 'Platform', width: { wch: 20 }, style: defaultHeaderCss },
            { title: `${isExpertPost ? 'URL' : ''}`, width: { wch: 60 }, style: defaultHeaderCss },
            {
              title: `${isExpertPost ? 'Consumer Comments Analysis' : ''}`,
              width: { wch: 20 },
              style: defaultHeaderCss,
            },
            {
              title: `${isExpertPost ? 'Net Sentiment' : ''}`,
              width: { wch: 20 },
              style: defaultHeaderCss,
            },
            {
              title: `${isExpertPost ? 'Expert Post Title' : ''}`,
              width: { wch: 40 },
              style: defaultHeaderCss,
            },
            {
              title: `${isExpertPost ? 'Expert Post Sentiment' : ''}`,
              width: { wch: 20 },
              style: defaultHeaderCss,
            },
            {
              title: `${isExpertPost ? 'Expert Post URL' : ''}`,
              width: { wch: 60 },
              style: defaultHeaderCss,
            },
          ],
          data: objNew,
        },
      ])
      setExcelSheetName('Impact Destinations')
    } else if (
      [
        'BrandAttributeMapElement',
        'BrandAttributeMapAndProgression',
        'TriangulationMapAndProgression',
        'TriangulationMapElement',
      ].includes(type)
    ) {
      // let objNew = []
      // let isExpertPost = (data?.filter(f => (f?.ExpertPostTitle?.length > 0 && f?.ExpertPostSentiment?.length > 0 && f?.ExpertPostURL?.length > 0)))?.length
      // for(let i=0; i<data?.length; i++){
      //     const item = data[i]
      //     objNew.push([
      //         { value: `${item.DriverName}` },
      //         { value: `${item.PercentEngagement}` },
      //         { value: `${item.Sentiment}` }
      //     ])
      // }
      setState([
        {
          columns: [
            { title: 'Name', width: { wch: 40 }, style: defaultHeaderCss },
            { title: 'Percent Engagement', width: { wch: 20 }, style: defaultHeaderCss },
            { title: 'Net Sentiment', width: { wch: 20 }, style: defaultHeaderCss },
          ],
          data: data,
        },
      ])
      setExcelSheetName('Brand Attribute Map')
    } else if (type === 'BusinessObjective') {
      const objNew = data.map((d) => {
        let val =
          d.value.indexOf('#####') !== -1
            ? { value: d.value.replace('######', ''), style: defaultHeaderCss }
            : d
        return [val]
      })
      setState([
        {
          columns: [{ title: '', width: { wch: 130 }, style: defaultHeaderCss }],
          data: objNew,
        },
      ])
      setExcelSheetName('Business Objective')
    } else if (type === 'Recommendation' || type === 'RecommendationAndProgression') {
      const objNew = data.map((d) => {
        const css = d.tag === 'H4' ? defaultHeaderCss : {}
        return [{ ...d, style: css }]
      })
      setState([
        {
          columns: [{ title: '', width: { wch: 130 }, style: defaultHeaderCss }],
          data: objNew,
        },
      ])
      setExcelSheetName('Recommendation')
    } else if (['Aura',
      'AuraAndProgression',
      'AuraAndComparison',
      'AuraAndProgressionAndComparison',
      'AuraWithoutSentiments',
      'AuraWithoutSentimentsAndProgression',
      'AuraWithoutSentimentsAndComparison',
      'AuraWithoutSentimentsAndProgressionAndComparison'].includes(type)) {
      const objNew = data
      setState([
        {
          columns: [
            { title: 'Impact Words', width: { wch: 50 }, style: defaultHeaderCss },
            { title: 'Sentiment', width: { wch: 30 }, style: defaultHeaderCss },
          ],
          data: objNew,
        },
      ])
      setExcelSheetName(type)
    } else if (
      [
        'InsightsMiningFrameworkWithSentiments',
        'InsightsMiningFrameworkWithoutSentiments',
      ].includes(type)
    ) {
      const sentimentsHeader = ['InsightsMiningFrameworkWithoutSentiments'].includes(type)
        ? []
        : [
            ...sentimentsArray,
            ...[{ title: 'Total Percent', width: { wch: 15 }, style: defaultHeaderCss }],
          ]
      const dataWithoutSentiments = data?.map((d) => {
        return [{ value: d[0].value }, { value: d[1].value }, { value: d[2].value }]
      })
      const objNew = ['InsightsMiningFrameworkWithoutSentiments'].includes(type)
        ? dataWithoutSentiments
        : data
      setState([
        {
          columns: [
            { title: 'Driver', width: { wch: 50 }, style: defaultHeaderCss },
            { title: 'Attribute', width: { wch: 50 }, style: defaultHeaderCss },
            { title: 'Sub Attribute', width: { wch: 50 }, style: defaultHeaderCss },
            ...sentimentsHeader,
          ],
          data: objNew,
        },
      ])
      setExcelSheetName('Insights Mining Framework Without Sentiments')
    } else if (
      [
        'SearchDrivers',
        'DriversAndSubBrands',
        'DriversWithoutSentimentsAndSubBrands',
        'DriversWithoutSentiments',
        'DriversAndTriggers',
        'Drivers',
        'DriversAndSubBrandsMotivatorsDetractors',
        'DriversAndTriggersMotivatorsDetractors',
        'DriversAndRatingImpactsMotivatorsDetractors',
        'DriversMotivatorsDetractors',
        'DriversWithoutSentimentsMotivatorsDetractors',

        'TopRelativeBrandsAnalysis',
      ].includes(type)
    ) {
      const sentimentsHeader = ['TopRelativeBrandsAnalysis', 'SearchDrivers', 'DriversWithoutSentiments'].includes(type)
        ? []
        : sentimentsArray

      const drivers = data.drivers?.map((d) => {
        return [{ value: d[0].value }, { value: d[5].value, style: d[5].style || {} }]
      })
      // const data_drivers = ['SearchDrivers', 'DriversWithoutSentiments'].includes(type) ? drivers : data.drivers
      let data_drivers = data.drivers
      if (['TopRelativeBrandsAnalysis', 'SearchDrivers', 'DriversWithoutSentiments'].includes(type)) {
        data_drivers = drivers
      } else if (
        [
          'DriversAndSubBrands',
          'DriversWithoutSentimentsAndSubBrands',
          'DriversAndSubBrandsMotivatorsDetractors',
        ].includes(type)
      ) {
        data_drivers = data.driverSubBrandStandouts
      } else if (['DriversAndTriggers', 'DriversAndTriggersMotivatorsDetractors'].includes(type)) {
        data_drivers = data.driverTriggerStandouts
      }

      const heading_subBrands = [
        'DriversAndSubBrands',
        'DriversWithoutSentimentsAndSubBrands',
        'DriversAndSubBrandsMotivatorsDetractors',
      ].includes(type)
        ? [{ title: 'Sub-brands', width: { wch: 25 }, style: defaultHeaderCss }]
        : []
      const heading_triggers = [
        'DriversAndTriggers',
        'DriversAndTriggersMotivatorsDetractors',
      ].includes(type)
        ? [{ title: 'Triggers', width: { wch: 40 }, style: defaultHeaderCss }]
        : []

      const cols = [
            ...[{ title: 'Driver', width: { wch: 30 }, style: defaultHeaderCss }],
            ...sentimentsHeader,
            ...[{ title: 'Total Percent', width: { wch: 15 }, style: defaultHeaderCss }],
            ...heading_subBrands,
            ...heading_triggers,
          ]

      setState([
        {
          columns: ['TopRelativeBrandsAnalysis'].includes(type) ? [] : cols,
          data: data_drivers,
        },
      ])
      setExcelSheetName('Drivers')

      if (data?.attributes?.length) {
        const attributes = data.attributes?.map((d) => {
          return [
            { value: d[0].value },
            { value: d[1].value },
            { value: d[6].value, style: d[5].style || {} },
          ]
        })
        const data_attributes = ['TopRelativeBrandsAnalysis', 'SearchDrivers', 'DriversWithoutSentiments'].includes(type)
          ? attributes
          : data.attributes
        setState2([
          {
            columns: [
              ...[{ title: 'Driver', width: { wch: 30 }, style: defaultHeaderCss }],
              ...[{ title: 'Attributes', width: { wch: 30 }, style: defaultHeaderCss }],
              ...sentimentsHeader,
              ...[{ title: 'Total Percent', width: { wch: 15 }, style: defaultHeaderCss }],
            ],
            data: data_attributes,
          },
        ])
        setExcelSheetName2('Attributes')

        if (data?.subAttributes?.length) {
          const subAttributes = data.subAttributes?.map((d) => {
            return [
              { value: d[0].value },
              { value: d[1].value },
              { value: d[2].value },
              { value: d[7].value, style: d[5].style || {} },
            ]
          })
          const data_subAttributes = ['TopRelativeBrandsAnalysis', 'SearchDrivers', 'DriversWithoutSentiments'].includes(type)
            ? subAttributes
            : data.subAttributes
          setState3([
            {
              columns: [
                ...[{ title: 'Driver', width: { wch: 30 }, style: defaultHeaderCss }],
                ...[{ title: 'Attributes', width: { wch: 30 }, style: defaultHeaderCss }],
                ...[{ title: 'Sub Attribute', width: { wch: 30 }, style: defaultHeaderCss }],
                ...sentimentsHeader,
                ...[{ title: 'Total Percent', width: { wch: 15 }, style: defaultHeaderCss }],
              ],
              data: data_subAttributes,
            },
          ])
          setExcelSheetName3('Sub Attributes')

          if (['SearchDrivers'].includes(type)) {
            setState4(getSearchDriversKeywordsList(data.pptVerbatims))
            setExcelSheetName4('Search Words')
            setSheetCount(4)
          } else {
            setSheetCount(3)
          }
        } else {
          if (['SearchDrivers'].includes(type)) {
            setState3(getSearchDriversKeywordsList(data.pptVerbatims))
            setExcelSheetName3('Search Words')
            setSheetCount(3)
          } else {
            setSheetCount(2)
          }
        }
      } else {
        if (['SearchDrivers'].includes(type)) {
          setState2(getSearchDriversKeywordsList(data.pptVerbatims))
          setExcelSheetName2('Search Words')
          setSheetCount(2)
        } else {
          setSheetCount(1)
        }
      }
    } else if (['DriversAndRatingImpacts'].includes(type)) {
      setState([
        {
          columns: [
            ...[{ title: 'Driver', width: { wch: 30 }, style: defaultHeaderCss }],
            ...[{ title: 'Impact on Star Rating', width: { wch: 30 }, style: defaultHeaderCss }],
            ...sentimentsArray,
            ...[{ title: 'Total Percent', width: { wch: 15 }, style: defaultHeaderCss }],
          ],
          data: data.driversAndRatingImpacts,
        },
      ])
      setExcelSheetName('Drivers and Rating Impacts')
    } else if (['BrandCategoryOverview', 'BrandCategoryOverviewAndProgression'].includes(type)) {
      setState([
        {
          columns: [
            ...[{ title: 'Brand/Category', width: { wch: 30 }, style: defaultHeaderCss }],
            ...sentimentsArray,
            ...[{ title: 'Engagement Index', width: { wch: 20 }, style: defaultHeaderCss }],
          ],
          data: data,
        },
      ])
      setExcelSheetName('Brand Category Overview')
    } else if (
      [
        'SegmentDriversAnalysis',
        'DriversProgression',
        'Triangulation',
        'TriangulationComparisonViewOnly',
        'SegmentDriversOnlyAnalysis',
        'SegmentDriversOnlyAnalysisWithoutSentiments',
      ].includes(type)
    ) {
      const heading2 = [
        'SearchDriversProgression',
        'DriversProgressionWithoutSentiments',
        'DriversProgression',
      ].includes(type)
        ? 'Period'
        : 'Segment'

      setState([
        {
          columns: [
            ...[{ title: 'Driver', width: { wch: 30 }, style: defaultHeaderCss }],
            ...[{ title: heading2, width: { wch: 30 }, style: defaultHeaderCss }],
            ...sentimentsArray,
            ...[{ title: 'Total Percent', width: { wch: 15 }, style: defaultHeaderCss }],
          ],
          data: data?.array || data?.drivers || [],
        },
      ])
      setExcelSheetName('Segments')

      if (['SegmentDriversAnalysis'].includes(type)) {
        setState2([
          {
            columns: [
              ...[{ title: 'Driver', width: { wch: 30 }, style: defaultHeaderCss }],
              ...[{ title: heading2, width: { wch: 30 }, style: defaultHeaderCss }],
              ...[{ title: 'Attributes', width: { wch: 50 }, style: defaultHeaderCss }],
              ...sentimentsArray,
              ...[{ title: 'Total Percent', width: { wch: 15 }, style: defaultHeaderCss }],
            ],
            // data: data.arrayWithAttribute,
            data: data?.arrayWithAttribute || data?.attributes || [],
          },
        ])
        setExcelSheetName2('Attributes')
        setSheetCount(2)
      }
    } else if (
      ['SearchDriversProgression'].includes(type)
    ) {
      // const isData = Array.isArray(data) ? data : [data]
      const isData = Array.isArray(data) ? data : data.array
      const finalData =
        isData?.map((d) => {
          return [
            { value: d[0].value },
            { value: d[1].value },
            { value: d[6].value, style: d[6].style },
          ]
        }) || []
      const heading2 = [
        'SearchDriversProgression',
        'DriversProgression',
      ].includes(type)
        ? 'Period'
        : 'Segment'
      setState([
        {
          columns: [
            { title: 'Driver', width: { wch: 30 }, style: defaultHeaderCss },
            { title: heading2, width: { wch: 30 }, style: defaultHeaderCss },
            { title: 'Total Percent', width: { wch: 15 }, style: defaultHeaderCss },
          ],
          data: finalData,
        },
      ])
      setExcelSheetName('Segments')
    } else if (['DriversProgressionWithoutSentiments'].includes(type)) {
      const isData = Array.isArray(data) ? data : data?.array || data.drivers
      const finalData =
        isData?.map((d) => {
          return [
            { value: d[0].value },
            { value: d[1].value },
            { value: d[6].value, style: d[6].style },
          ]
        }) || []
      const heading2 = 'Period'
      setState([
        {
          columns: [
            { title: 'Driver', width: { wch: 30 }, style: defaultHeaderCss },
            { title: heading2, width: { wch: 30 }, style: defaultHeaderCss },
            { title: 'Total Percent', width: { wch: 15 }, style: defaultHeaderCss },
          ],
          data: finalData,
        },
      ])
      setExcelSheetName('Segments')
    } else if (['DriversProgressionWithoutSentiments'].includes(type)) {
      const isData = Array.isArray(data) ? data : data.array
      const finalData =
        isData?.map((d) => {
          return [
            { value: d[0].value },
            { value: d[1].value },
            { value: d[6].value, style: d[6].style },
          ]
        }) || []
      const heading2 = 'Period'
      setState([
        {
          columns: [
            { title: 'Driver', width: { wch: 30 }, style: defaultHeaderCss },
            { title: heading2, width: { wch: 30 }, style: defaultHeaderCss },
            { title: 'Total Percent', width: { wch: 15 }, style: defaultHeaderCss },
          ],
          data: finalData,
        },
      ])
      setExcelSheetName('Segments')
    } else if (
      [
        'SegmentOfSegmentOverview',
        'SegmentOfSegmentOverviewAndProgression',
        'SegmentOfSegmentOverview20Colors',
        'SegmentAndSegmentOfSegment',
        'SegmentAndSegmentProgression',
        'SegmentProgressionOverview'
      ].includes(type)
    ) {
      setState([
        {
          columns: [
            { title: 'Type', width: { wch: 30 }, style: defaultHeaderCss },
            { title: 'Segment', width: { wch: 30 }, style: defaultHeaderCss },
            { title: 'Percent', width: { wch: 15 }, style: defaultHeaderCss },
          ],
          data: data,
        },
      ])
      setExcelSheetName('Segments')
    } else if (
      [
        'SegmentOverview',
        // 'TopRelativeBrandsAnalysis',
        'AllRelativeBrandsAnalysis',
        'BuzzMetrics',
        'ProductRatingOptimizationSetup',
        'BrandHealthSetup',
        'CategoryExplorationSetup',
        'MultiBrandNPS',
      ].includes(type)
    ) {
      // nameValueObjects ...
      setState([
        {
          columns: [
            { title: data?.heading[0] || 'Segment', width: { wch: 30 }, style: defaultHeaderCss },
            { title: data?.heading[1] || 'Percent', width: { wch: 20 }, style: defaultHeaderCss },
          ],
          data: data.values,
        },
      ])
      setExcelSheetName(data?.sheetName || type)
    } else if (['BrandImageryMappingTable', 'CompetitiveLandscape', 'CompetitiveLandscapeBrandImagery'].includes(type)) {
      setState([
        {
          columns: data.heading.map((d) => {
            return { ...d, width: { wch: 25 }, style: { ...defaultHeaderCss } }
          }),
          data: data.values,
        },
      ])
      setExcelSheetName(data?.sheetName || type)
    } else if (['CustomTable'].includes(type)) {
      const valuesArray = data.values.map((d1) => {
        return d1.map((d2) => {
          return {
            ...d2,
            style: { alignment: { wrapText: true, horizontal: 'top', vertical: 'top' } },
          }
        })
      })
      setState([
        {
          columns: data.heading.map((d) => {
            return { ...d, width: { wch: 30 }, style: { ...defaultHeaderCss } }
          }),
          data: valuesArray,
        },
      ])
      setExcelSheetName(data?.sheetName || type)
    } else if (['CampaignAndIssuesAssessmentSetup'].includes(type)) {
      setState([{ columns: data.heading, data: data.values }])
      setExcelSheetName('Campaign And Issues Assessment Setup')
    } else if (['BrandMagnetScore', 'BrandMagnetScoreAndProgression'].includes(type)) {
      setState([{ columns: data.sheet1.heading, data: data.sheet1.values }])
      setExcelSheetName('Brand Magnet Score')
      if (data?.sheet2?.values?.length > 0) {
        setState2([{ columns: data.sheet2.heading, data: data.sheet2.values }])
        setExcelSheetName2('Brand Magnet Score Details')
        setSheetCount(2)
      }
    } else if (
      ['BrandImageryMappingGraph', 'BrandImageryMappingAndProgressionGraph'].includes(type)
    ) {
      setState([{ columns: data.sheet1.heading, data: data.sheet1.values }])
      setExcelSheetName('Brand Imagery Mapping Graph')
      if (data?.sheet2?.values?.length > 0) {
        setState2([{ columns: data.sheet2.heading, data: data.sheet2.values }])
        setExcelSheetName2('Brand Imagery Mapping Graph Details')
        setSheetCount(2)
      }
    } else if (['CampaignTriggers'].includes(type)) {
      setState([{ columns: data.sheet1.heading, data: data.sheet1.values }])
      setExcelSheetName('Campaign Triggers')
      setState2([{ columns: data.sheet2.heading, data: data.sheet2.values }])
      setExcelSheetName2('Campaign Triggers Details')
      setSheetCount(2)
    } else if (
      [
        'SegmentDriversOnlyAnalysis3Level',
        'SegmentDriversOnlyAnalysisWithoutSentiments',
        'SegmentDriversOnlyAnalysisWithoutSentiments3Level',
        'SearchDriversProgression3Level_v1',
        'DriversProgression3Level_v1',
        'DriversProgressionWithoutSentiments3Level_v1',
        'SearchDriversProgression3Level',
        'DriversProgression3Level',
        'DriversProgressionWithoutSentiments3Level',
      ].includes(type)
    ) {
      const sentimentsHeader = [
        'SearchDriversProgression3Level_v1',
        'DriversProgressionWithoutSentiments3Level_v1',
        'SearchDriversProgression3Level',
        'DriversProgressionWithoutSentiments3Level',
      ].includes(type)
        ? []
        : sentimentsArray

      const drivers = data.drivers?.map((d) => {
        return [
          { value: d[0].value },
          { value: d[1].value },
          { value: d[6].value, style: d[5].style || {} },
        ]
      })
      const data_drivers = [
        'SearchDriversProgression3Level_v1',
        'DriversProgressionWithoutSentiments3Level_v1',
        'SearchDriversProgression3Level',
        'DriversProgressionWithoutSentiments3Level',
      ].includes(type)
        ? drivers
        : data.drivers

      setState([
        {
          columns: [
            ...[{ title: 'Driver', width: { wch: 30 }, style: defaultHeaderCss }],
            ...[{ title: 'Segment', width: { wch: 30 }, style: defaultHeaderCss }],
            ...sentimentsHeader,
            ...[{ title: 'Total Percent', width: { wch: 15 }, style: defaultHeaderCss }],
          ],
          data: data_drivers,
        },
      ])
      setExcelSheetName('Drivers')

      if (data?.attributes?.length) {
        // const data_attributes = data.attributes
        const attributes = data.attributes?.map((d) => {
          return [
            { value: d[0].value },
            { value: d[1].value },
            { value: d[2].value },
            { value: d[7].value, style: d[5].style || {} },
          ]
        })
        const data_attributes = [
          'SearchDriversProgression3Level_v1',
          'DriversProgressionWithoutSentiments3Level_v1',
          'SearchDriversProgression3Level',
          'DriversProgressionWithoutSentiments3Level',
        ].includes(type)
          ? attributes
          : data.attributes
        setState2([
          {
            columns: [
              ...[{ title: 'Driver', width: { wch: 30 }, style: defaultHeaderCss }],
              ...[{ title: 'Segment', width: { wch: 30 }, style: defaultHeaderCss }],
              ...[{ title: 'Attributes', width: { wch: 30 }, style: defaultHeaderCss }],
              ...sentimentsHeader,
              ...[{ title: 'Total Percent', width: { wch: 15 }, style: defaultHeaderCss }],
            ],
            data: data_attributes,
          },
        ])
        setExcelSheetName2('Attributes')

        if (data?.subAttributes?.length) {
          const subAttributes = data.subAttributes?.map((d) => {
            return [
              { value: d[0].value },
              { value: d[1].value },
              { value: d[2].value },
              { value: d[3].value },
              { value: d[8].value, style: d[5].style || {} },
            ]
          })
          const data_subAttributes = [
            'SearchDriversProgression3Level_v1',
            'DriversProgressionWithoutSentiments3Level_v1',
            'SearchDriversProgression3Level',
            'DriversProgressionWithoutSentiments3Level',
          ].includes(type)
            ? subAttributes
            : data.subAttributes
          // const data_subAttributes = data.subAttributes
          setState3([
            {
              columns: [
                ...[{ title: 'Driver', width: { wch: 30 }, style: defaultHeaderCss }],
                ...[{ title: 'Segment', width: { wch: 30 }, style: defaultHeaderCss }],
                ...[{ title: 'Attributes', width: { wch: 30 }, style: defaultHeaderCss }],
                ...[{ title: 'Sub Attribute', width: { wch: 30 }, style: defaultHeaderCss }],
                ...sentimentsArray,
                ...[{ title: 'Total Percent', width: { wch: 15 }, style: defaultHeaderCss }],
              ],
              data: data_subAttributes,
            },
          ])
          setExcelSheetName3('Sub Attributes')
          setSheetCount(3)
        } else {
          setSheetCount(2)
        }
      } else {
        setSheetCount(1)
      }
    } else if (['FactorInterlinkage'].includes(type)) {
      setState([
        {
          columns: [
            { title: 'Factor', width: { wch: 30 }, style: defaultHeaderCss },
            { title: 'Linked Factor', width: { wch: 30 }, style: defaultHeaderCss },
            { title: 'Linkage Percent', width: { wch: 15 }, style: defaultHeaderCss },
          ],
          data: data,
        },
      ])
      setExcelSheetName('Factor Interlinkage')
    } else if (['CategoryPersona'].includes(type)) {
      if (data.brandSkew.length > 0) {
        setState([
          {
            columns: [
              { title: 'SegmentName', width: { wch: 30 }, style: defaultHeaderCss },
            ],
            data: data.brandSkew,
          },
        ])
        setExcelSheetName('Brand Skew')
      }

      if (data.properties.length > 0) {
        setState2([
          {
            columns: [
              { title: 'PersonaPropertyName', width: { wch: 30 }, style: defaultHeaderCss },
              { title: 'PersonaPropertyValue', width: { wch: 30 }, style: defaultHeaderCss },
            ],
            data: data.properties,
          },
        ])
        setExcelSheetName2('Properties')
        setSheetCount(2)
      }
     
      if (data?.behaviors?.length > 0) {
        setState3([
          {
            columns: [
              { title: 'PersonaBehaviorName', width: { wch: 30 }, style: defaultHeaderCss },
              { title: 'PersonaBehaviorAttribute', width: { wch: 30 }, style: defaultHeaderCss },
            ],
            data: data.behaviors,
          },
        ])
        setExcelSheetName3('Behaviors')
        setSheetCount(3)
      }

      if (data?.categoryDrivers?.length > 0) {
        setState4([
          {
            columns: [
              { title: 'PersonaDriverName', width: { wch: 30 }, style: defaultHeaderCss },
              { title: 'PersonaDriverPercent', width: { wch: 30 }, style: defaultHeaderCss },
              { title: 'PersonaDriverDescription', width: { wch: 50 }, style: defaultHeaderCss },
            ],
            data: data.categoryDrivers,
          },
        ])
        setExcelSheetName4('Category Drivers')
        setSheetCount(4)
      }

    }

    // if(excelSheetName === 'Sheet 1') { setExcelSheetName(type) }
    // if(excelSheetName2 === 'Sheet 2') { setExcelSheetName2(type) }
    // if(excelSheetName3 === 'Sheet 3') { setExcelSheetName3(type) }
    // if(excelSheetName4 === 'Sheet 4') { setExcelSheetName4(type) }
  }

  useEffect(() => {
    if (data) {
      const dataLength = Array.isArray(data) ? data?.length : Object.keys(data)?.length
      if (dataLength > 0) {
        generateExcelData()
      }
    }
  }, [data])

  const onLoadSaveCsvData = () => {
    if (isCSVModalActive) {
      const generateFileName = (filename, sheetName) => {
        const formatString = (str) => {
          let str1 = str
            ?.trim()
            .toLowerCase()
            .replaceAll(' ', '_')
            .replaceAll('download--', '')
            .replaceAll('-', '_')
            .replace(/[^a-zA-Z0-9_]/g, '')
          // if(str1.length > 40) str1 = str1.substring(0, 40)
          return str1
        }
        // ret `csv____${type}____${downloadId               }____${filename              }____${sheetName}`
        return `csv____${type}____${downloadId.split('__')[1]}____${formatString(filename)}____${formatString(sheetName)}____${mainTitle}____${parentTitle}____${InsightsElementId}____${tabId}`
        // return `csv____id____${downloadId.split('__')[1]}____${formatString(filename)}____${formatString(sheetName)}`
      }

      const removeAdditionalKeys = (data, sheetName) => {
        if (data?.length === 0) return []
        if (data?.length === 0 && data[0]?.length === 0) return []

        const finalData = []
        // if(data[0]?.columns?.length > 0){ finalData.push(data[0]?.columns.map(t => t.title).join(';')) }
        if (data[0]?.columns?.length > 0) {
          finalData.push(data[0]?.columns.map((t) => t.title))
        }
        if (data[0]?.data?.length > 0) {
          const addComma = (val) => {
            if (typeof val === 'number') {
              return val
            } else if (typeof val === 'string') {
              let str = val + ''
              str = str.replace(/^\n/, '') // Replace `\n` at the start with `#`
              str = str.replace(/\n(?!$)/g, ' | ') // Replace all `\n` except the last one with a comma
              str = str.replace(/\n$/, '') // Replace `\n` at the end with a space
              return str
            } else if (typeof val === 'object') {
              return val.value
            }
          }

          // const array = data[0]?.data.map(v1 => (v1.map(v2 => addComma((v2?.value || v2)+''))) ).map(v => v.join(';'))
          const array = data[0]?.data.map((v1) => v1.map((v2) => addComma(v2?.value || v2)))
          finalData.push(...array)
        }
        return finalData
      }

      // Array of sheet names and corresponding states
      const sheetNames = [excelSheetName, excelSheetName2, excelSheetName3, excelSheetName4]
      const states = [
        removeAdditionalKeys(state, excelSheetName),
        removeAdditionalKeys(state2, excelSheetName2),
        removeAdditionalKeys(state3, excelSheetName3),
        removeAdditionalKeys(state4, excelSheetName4),
      ]
      // const sheetNames = [excelSheetName]
      // const states = [removeAdditionalKeys(state, excelSheetName)]

      // Generate file names dynamically
      const fileNames = sheetNames
        .slice(0, sheetCount)
        .map((sheet) => generateFileName(filename, sheet))

      // Construct object dynamically
      const obj = Object.fromEntries(
        fileNames
          .map((name, i) => (states[i]?.length > 0 ? [name, states[i]] : null))
          .filter(Boolean)
      )
      
      if (Object.keys(obj).length > 0) {
        // if the type is this then we are allowing our exportToCsvObject to override.
        if (type.includes('SegmentAndSegmentOfSegment') || type.includes('CompetitiveLandscape' || type.includes('CompetitiveLandscapeBrandImagery'))) {
          updatingExportToCsvObject(obj , true)
        } else {
          updatingExportToCsvObject(obj)
        }
      } else if (data === undefined) {
        const emptyObj = Object.fromEntries(fileNames.map((name) => [name, []]))
        updatingExportToCsvObject(emptyObj)
      } else {
        // const emptyObj = Object.fromEntries(fileNames.map((name) => [name, []]))
        // updatingExportToCsvObject(emptyObj)
      }
    }
  }

  // useEffect(() => {
  //     console.log('>>>> sheetCount, state, excelSheetName=======', sheetCount, state, excelSheetName)
  //     if(sheetCount === 1 && state.length > 0) onLoadSaveCsvData() //  && excelSheetName !== 'Sheet 1'
  //     else if(sheetCount === 2 && state2.length > 0) onLoadSaveCsvData() //  && excelSheetName2 !== 'Sheet 2'
  //     else if(sheetCount === 3 && state3.length > 0) onLoadSaveCsvData() //  && excelSheetName3 !== 'Sheet 3'
  //     else if(sheetCount === 4 && state4.length > 0) onLoadSaveCsvData() //  && excelSheetName4 !== 'Sheet 4'
  // }, [
  //     state, state2, state3, state4,
  //     excelSheetName, excelSheetName2, excelSheetName3, excelSheetName4,
  //     isCSVModalActive
  // ])

  useEffect(() => {
    onLoadSaveCsvData()
  }, [state, state2, state3, state4])

  return (
    <>
      {sheetCount === 1 && (
        <ExcelFile element={<DownloadButton buttonName={buttonName} />} filename={filename}>
          <ExcelSheet dataSet={state} name={excelSheetName} />
        </ExcelFile>
      )}
      {sheetCount === 2 && (
        <ExcelFile element={<DownloadButton buttonName={buttonName} />} filename={filename}>
          <ExcelSheet dataSet={state} name={excelSheetName} />
          {state2?.length > 0 && <ExcelSheet dataSet={state2} name={excelSheetName2} />}
        </ExcelFile>
      )}
      {sheetCount === 3 && (
        <ExcelFile element={<DownloadButton buttonName={buttonName} />} filename={filename}>
          <ExcelSheet dataSet={state} name={excelSheetName} />
          {state2?.length > 0 && <ExcelSheet dataSet={state2} name={excelSheetName2} />}
          {state3?.length > 0 && <ExcelSheet dataSet={state3} name={excelSheetName3} />}
        </ExcelFile>
      )}
      {sheetCount === 4 && (
        <ExcelFile element={<DownloadButton buttonName={buttonName} />} filename={filename}>
          <ExcelSheet dataSet={state} name={excelSheetName} />
          {state2?.length > 0 && <ExcelSheet dataSet={state2} name={excelSheetName2} />}
          {state3?.length > 0 && <ExcelSheet dataSet={state3} name={excelSheetName3} />}
          {state4?.length > 0 && <ExcelSheet dataSet={state4} name={excelSheetName4} />}
        </ExcelFile>
      )}
    </>
  )
}

export default DownloadExcelContent

const DownloadButton = ({ buttonName }) => {
  return (
    <>
      {/* <IsLocalHost><div style={{background:'green', height:'100%', color:'#fff', padding:'0 15px', lineHeight:'32px'}}>Excel-3</div></IsLocalHost> */}
      {/* <MuiButtons className='BtnExportToExcel' buttonType='exportToExcel' /> */}
      <MuiButton
        className='BtnExportToExcel'
        color='light'
        variant='outlined'
        label='Export'
        startIcon={<IconExcel />}
      >
        {buttonName}
      </MuiButton>
      {/* <MuiButton className='BtnExportToExcel' variant='standard' color='primary' sx={{color:'#095BBD'}}><Download /> &nbsp; {buttonName}</MuiButton> */}
    </>
  )
}
